<template>
  <v-layout
    justify-center
    wrap
  >
    <v-flex
      xs12
      pl-0
      pr-0
      class="fill-height"
    >
      <v-card class="pt-7 pl-0 pr-0">
        <v-form>
          <v-layout         
            wrap
          >            
            <v-flex
              xs12
            >
              <v-text-field
                v-model.trim="form.name"
                :error-messages="NameErrors"
                :label="$t('modules.sectionName')+ '*'"
                required
                @input="$v.form.name.$touch()"
                @blur="$v.form.name.$touch()"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              class="text-right"
              pt-0
              pb-0
            >
              <v-btn
                text
                :disabled="loading"
                @click="$emit('closeEditSection', false)"
              >
                <span>{{ $t('globals.cancelButton') }}</span>
              </v-btn>
              <v-btn
                color="primary"
                :disabled="loading || $v.$invalid"
                :loading="loading"
                @click="save()"
              >
                {{ $t('globals.saveButton') }}
              </v-btn>
            </v-flex>
          </v-layout> 
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import SECTION_CREATE_MUTATION from "@/graphql/mutations/modules/LmsSectionCreate.gql";
import SECTION_UPDATE_MUTATION from "@/graphql/mutations/modules/LmsSectionUpdate.gql";

export default {
  name: 'NewOrEditSection',
  mixins: [validationMixin],
  props: {
    whitelabelUuid: {
      type: String,
      default: null
    },
    section: {
      type: Object,
      default: null
    },
    courseUuid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: ""
      }
    }
  },
  computed: {
    rules() {
      return {
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100),
        }
      }
    },
    NameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.name.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.name.$params.minLength.min}));
      !this.$v.form.name.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.name.$params.maxLength.max}));
      return errors;
    }
  },
  mounted() {
    const formSection = JSON.parse(JSON.stringify(this.section))
    if (formSection) {      
      this.form = formSection
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      }
      
      this.loading = true;
      this.form.whitelabel_uuid = this.whitelabelUuid;
      if(this.courseUuid) {
        this.form.course_uuid = this.courseUuid;
      }
      if(this.section) this.form.section_id = this.section.id
      this.$apollo
        .mutate({
          mutation: !this.section ? SECTION_CREATE_MUTATION : SECTION_UPDATE_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.loading = false;
          this.$emit('closeEditSection', true);
        })
        .catch(error => {
          this.errorHandler(error);
          this.$emit('closeEditSection', false);
        });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>